<template>
  <div class="clue-config-item clearfix">
    <a-form-item
      label=""
    >
      <i
        class="icon iconfont iconicon-test72 draggable-item-icon"
      />
      <a-cascader
        v-decorator="[
          itemData.fieldkey+ 'fieldkey' + index,
          {
            validateTrigger: ['change'],
            rules: [{ required: true, message: '请选择线索跟进字段' }], initialValue: val},

        ]"
        :field-names="{ label: 'fieldname', value: 'fieldkey', children: 'child' }"
        :options="fields"
        placeholder="请选择"

        @change="handleChange"
      />
    </a-form-item>
    <div
      class="follow-item"
    >
      <a-form-item>
        每 <a-input-number
          v-decorator="[itemData.fieldkey + 'cycle', { initialValue: itemData.follow.cycle }]"
          :min="0"
          :max="365"
          @change="handleChange2($event, 'cycle')"
        />
        天跟进一次，需要跟进
      </a-form-item>
      <a-form-item>
        <a-input-number
          v-decorator="[itemData.fieldkey + 'number', { initialValue: itemData.follow.number }]"
          :min="0"
          :max="99"
          @change="handleChange2($event, 'number')"
        />
        次
      </a-form-item>
      <a-form-item>
        <a
          href="javascript:;"
          class="del-clue-item-btn fl"
          @click="remove(index)"
        >
          {{ $t('message["962"]') }}
        </a>
      </a-form-item>
      <!-- <a-form-item>
        <a-input-number
          v-decorator="[itemData.fieldkey + 'priority', { initialValue: 0 }]"
          :min="1"
          :max="10"
          @change="handleChange($event, 'priority')"
        />
      </a-form-item> -->
      <a-form-item>
        <a-checkbox
          :checked="!!itemData.follow.invalid"
          @change="followChange"
        >
          线索无效条件
        </a-checkbox>
      </a-form-item>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      configDatas: []
    }
  },
  inject: {
    myForm: {
      default: () => ({})
    }
  },
  computed: {
    ...mapState('config/clue', ['datas', 'configFields']),
    fields () {
      const { configFields = [], datas = {} } = this
      const { 'followup_field': fieldinfo = [] } = datas
      let configDatas = []
      let tempArr = cloneDeep(configFields)
      const tempConfigDatas = tempArr.filter(item => item.fieldkey !== 'from_info')
      if (this.itemData.fieldkey === 'from_info' || !fieldinfo.some(item => item.fieldkey === 'from_info')) {
        configDatas = tempConfigDatas.filter(item => item.fieldkey !== 'base_info' && item.fieldkey !== 'deal_info' && item.fieldkey !== 'invalid_info' && item.fieldkey !== 'discard_info' && item.fieldkey !== 'reception_info')
      } else {
        configDatas = tempConfigDatas.filter(item => item.fieldkey !== 'base_info' && item.fieldkey !== 'deal_info' && item.fieldkey !== 'invalid_info' && item.fieldkey !== 'discard_info' && item.fieldkey !== 'reception_info' && (item.fieldkey !== 'from_info'))
      }

      fieldinfo.forEach(element => {
        configDatas.forEach((item, index) => {
          if (item.child && item.child.length > 0) {
            item.child = item.child.filter(item2 => (item2.fieldkey !== element.fieldkey || element.fieldkey === this.itemData.fieldkey) && item2.fieldtype !== 'file')
          } else if (item.fieldkey !== 'from_info') {
            configDatas.splice(index, 1)
          }
        })
      })
      return configDatas
    },
    val () {
      const { itemData } = this
      const { parentkey, fieldkey } = itemData
      let arr = []
      if (parentkey && fieldkey) {
        arr = [parentkey, fieldkey]
      } else if (!parentkey && fieldkey) {
        arr = [fieldkey]
      } else {
        arr = []
      }
      return arr
    },
    isenabled () {
      const { fieldtype } = this.itemData
      return fieldtype !== 'text' && fieldtype !== 'email' && fieldtype !== 'phone'
    }
  },
  mounted () {
  },
  methods: {
    followChange (e) {
      this.itemData.follow.invalid = e.target.checked ? 1 : 0
    },
    handleChange (val, item) {
      if (item) {
        const isHasParent = item.length > 1
        this.$set(this.itemData, 'parentkey', isHasParent ? val[0] : '')
        this.$set(this.itemData, 'fieldkey', isHasParent ? val[1] : val[0])
        this.$set(this.itemData, 'fieldname', isHasParent ? item[1].fieldname : item[0].fieldname)
        this.$set(this.itemData, 'fieldtype', isHasParent ? item[1].fieldtype : item[0].fieldtype)
      } else {
        this.itemData.fieldtype = ''
        this.itemData.parentkey = ''
        this.itemData.fieldname = ''
        this.itemData.fieldkey = ''
      }
      this.$nextTick(() => {
        this.myForm.setFieldsValue({
          [this.itemData.fieldkey + 'fieldkey' + this.index]: this.val
        })
        this.myForm.validateFields([this.itemData.fieldkey + 'fieldkey' + this.index])
      })
    },
    handleChange2 (e, filedkey) {
      this.itemData.follow[filedkey] = e
    },
    fieldHanle () {

    },
    remove (index) {
      this.$emit('del', index)
    }
  }
}
</script>
<style lang="scss" scoped>
  .clue-config-item::v-deep{
    .ant-form-item{
      float: left;
      margin-right: 10px;
       .ant-cascader-picker{
         width: 240px;
       }
       .ant-input-number{
         width: 150px;
       }
    }
    .ant-form-explain{
      //margin-top: -12px;
      padding-bottom: 12px;
    }
  }
  .del-clue-item-btn{
    margin: 0  10px;
  }
  .iconicon-test72 {
    // font-size: 22px;
    // cursor: move;
    // color: #ccc;
  }
</style>
